import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { Button, Checkbox, Form, Input } from "react-daisyui";
import { mutations, wrapMutation } from "../../graphql";
import { BlockProps } from "../../containers/Block";

function JoinRoom({ block, currentUser, zone }: BlockProps) {
  const queryClient = useQueryClient();
  const [username, setUsername] = useState(currentUser?.username ?? "");
  const [asAuthenticated, setAsAuthenticated] = useState(!!currentUser);
  const joinZoneMutation = useMutation(wrapMutation(mutations.joinZone), {
    onSuccess: () => {
      queryClient.invalidateQueries();
    },
  });

  return (
    <div>
      {joinZoneMutation.isLoading ? (
        <div>Joining zone...</div>
      ) : (
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            joinZoneMutation.mutate({
              zoneId: zone.zoneId,
              accessManagerBlockId: block.blockId,
              asAuthenticated: asAuthenticated,
              username: username.trim() !== "" ? username.trim() : undefined,
            });
          }}
        >
          <div className="block">
            If you would like to join this Bandwagon, please select a username.
          </div>
          <Form.Label title="username">
            <Input
              placeholder="Select a nickname"
              value={username}
              onChange={(e) => {
                setUsername(e.target.value);
              }}
            />
          </Form.Label>
          <Form.Label title="as Anonymous">
            <Checkbox
              checked={!asAuthenticated}
              className="mx-4"
              disabled={!currentUser}
              onChange={(e) => setAsAuthenticated(!e.target.checked)}
            />
          </Form.Label>
          <Button type="submit" disabled={!username.trim()}>
            Join Room
          </Button>
        </Form>
      )}
    </div>
  );
}

function LeaveRoom({ zone, block }: BlockProps) {
  const queryClient = useQueryClient();
  const leaveZoneMutation = useMutation(wrapMutation(mutations.leaveZone), {
    onSuccess: () => {
      queryClient.removeQueries(["zone", zone.zoneId, "blocks"]);
      queryClient.invalidateQueries();
    },
  });
  return (
    <div>
      {leaveZoneMutation.isLoading ? (
        <div>Leaving zone...</div>
      ) : (
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            leaveZoneMutation.mutate({
              accessManagerBlockId: block.blockId,
              zoneId: zone.zoneId,
            });
          }}
        >
          <Button type="submit">Leave Room</Button>
        </Form>
      )}
    </div>
  );
}

export default function AccessManager(props: BlockProps) {
  if (!props.zone.participation) {
    return <JoinRoom {...props} />;
  } else {
    return <LeaveRoom {...props} />;
  }
  // return <div>AccessManager - {block.blockId}</div>;
}
